export default __webpack_public_path__ + "static/media/signViceMap.4c375827.png";